export default __webpack_public_path__ + "static/logo_assc_CMSDC@2x-5e983f75f4443ca3f3c76dce6ea5350d.png";